'use client';



import clsx from 'clsx';

import { PageSection, Reveal, RevealItem, SectionHeading } from '@/components/ui';

import { fadeUp } from '@/lib/motion';

import s from './PlatformCapabilities.module.css';

import { useTranslation } from '@/hooks/useTranslation';



/*

 * Platform Capabilities — the "6 engines" section.

 * Header matches homepage Customer Stories: lb-eyebrow + type-section-title-lg,

 * inline serif accent + second line, left-aligned.

 *

 * Props: { heading?, headingTitle?, headingAccent?, headingLine2?, subtitle, items, eyebrow?, bg? }

 */

export default function PlatformCapabilities({

  heading,

  headingKicker,

  headingKickerAccent,

  headingTitle,

  headingAccent,

  headingLine2,

  subtitle,

  items,

  eyebrow,

  bg = 'page',
  align = 'left',

}) {

  const { t } = useTranslation();

  if (!items || items.length === 0) return null;



  const useSplit = Boolean(headingTitle);
  const centered = align === 'center';



  return (

    <PageSection

      id="capabilities"

      bg={bg}

      className={clsx(s.section, bg === 'tint' && s.tintMesh)}

      aria-labelledby="caps-heading"

    >

      <Reveal variant={fadeUp} className={clsx(s.head, centered && s.headCenter)}>

        {useSplit ? (

          <SectionHeading

            eyebrow={eyebrow ? t(eyebrow) : undefined}

            kickerTitle={headingKicker ? t(headingKicker) : undefined}

            kickerAccent={headingKickerAccent ? t(headingKickerAccent) : undefined}

            title={t(headingTitle)}

            titleAccent={headingAccent ? t(headingAccent) : undefined}

            titleLine2={headingLine2 ? t(headingLine2) : undefined}

            size="lg"

            align={align}

            headingId="caps-heading"

            className={s.headingWrap}

            titleClassName={s.heading}

          />

        ) : (

          <>

            {eyebrow && <span className="lb-eyebrow">{t(eyebrow)}</span>}

            <h2 id="caps-heading" className={clsx('type-section-title-lg', s.heading)}>

              {t(heading)}

            </h2>

          </>

        )}

        {subtitle && (
          <p className={clsx('type-body', s.sub, centered && s.subCenter)}>{t(subtitle)}</p>
        )}

      </Reveal>



      <Reveal stagger={0.08} className={s.grid}>

        {items.map((it, i) => {

          const Icon = it.Icon;

          return (

            <RevealItem key={i} as="article" className={s.card}>

              <div className={clsx(s.visual, s[`visualAnim${i % 6}`])} aria-hidden="true">

                <span className={s.visualGlow} />

                <span className={s.visualDots} />

                {Icon && (

                  <span className={s.iconTile}>

                    <Icon size={30} strokeWidth={1.7} />

                  </span>

                )}

              </div>

              <h3 className={s.cardTitle}>{t(it.title)}</h3>

              <p className={s.cardBody}>{t(it.body)}</p>

            </RevealItem>

          );

        })}

      </Reveal>

    </PageSection>

  );

}


